import { validateAndUnwrapRefs } from "@mediamonks/react-kit";
import gsap from "gsap";
import type { M1ButtonRefs } from "./M1Button";
import { fadeFromTo } from "../../../animation/fade/fade.ts";

export function createInAnimation(
  refs: M1ButtonRefs,
  hasAnimation: boolean,
): gsap.core.Animation | undefined {
  const [isValid, validatedRefs] = validateAndUnwrapRefs(refs);

  if (!isValid || !hasAnimation) {
    return;
  }

  const { self } = validatedRefs;
  const timeline = gsap.timeline();

  timeline.add(fadeFromTo(self, { duration: 0.01 }));
  timeline.fromTo(
    self,
    {
      "--m1-button-background-progress": 0,
    },
    {
      "--m1-button-background-progress": 1,
      duration: 1,
      ease: "power3.out",
    },
    "<",
  );

  return timeline;
}
